
export default {
    name: 'FinAgentPersonalizedToggle',

    computed: {
        isEnabled() {
            return this.$store.state.preferences.finAgentPersonalizedEnabled;
        }
    },

    methods: {
        handleChange(newValue) {
            this.$store.commit('preferences/setFinAgentPersonalizedEnabled', newValue);
        },
        handleClickArea() {
            if (this.$vuetify.breakpoint.mdAndUp) {
                return;
            }

            this.$store.commit('preferences/setFinAgentPersonalizedEnabled', !this.isEnabled);
        }
    }
}
